import React from 'react';
import Avatar from 'shared/components/avatar/Avatar';
import { firstLetters } from 'utils/strings';
import { HashLink as Link } from 'react-router-hash-link';

const NotificationsLog = ({
  avatarImage,
  name,
  period,
  avatarUrl,
  title,
  message,
  detailedMessage,
  eventUrl
}) => {
  return (
    <div className="timeline-item notification-default">
      <Avatar
        src={avatarImage}
        width="32"
        height="32"
        name={name}
        text={`${period} ago`}
        firstLetters={firstLetters(name)}
        url={avatarUrl}
      />
      <div className="activity-info">
        {eventUrl ? (
          <Link
            to={eventUrl}
            scroll={el =>
              setTimeout(() => {
                el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }, 500)
            }
          >
            {title}
          </Link>
        ) : (
          <h4>{title}</h4>
        )}
        <p>{message}</p>
        <p>{detailedMessage}</p>
      </div>
    </div>
  );
};

export default NotificationsLog;
